import React, { useState, useEffect, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Package, Archive, Hand, ClipboardList, Layers } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useToast } from '@/components/ui/use-toast';
import RecoleccionPrendas from './components/RecoleccionPrendas';
import CasillerosGestion from './components/CasillerosGestion';
import EntregaPrendas from './components/EntregaPrendas';
import AlistamientoPrendas from './components/AlistamientoPrendas';
import PendientesEntrega from './components/PendientesEntrega';

const DepositoPage = () => {
  const { idPlanta } = useParams();
  const { toast } = useToast();
  const [planta, setPlanta] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('recoleccion');
  const [alistamientoCedula, setAlistamientoCedula] = useState('');

  const irAlistamiento = (cedula) => {
    setAlistamientoCedula(cedula);
    setActiveTab('alistamiento');
  };

  const loadPlanta = useCallback(async () => {
    setIsLoading(true);
    try {
      const { plantasService } = await import('@/pages/parametrizacion/plantas/utils/plantasService');
      const response = await plantasService.getById(idPlanta);
      setPlanta(response?.data || null);
    } catch (error) {
      console.error('Error cargando planta:', error);
      toast({
        title: 'Error',
        description: 'No se pudo cargar la información de la planta',
        variant: 'destructive',
      });
    } finally {
      setIsLoading(false);
    }
  }, [idPlanta, toast]);

  useEffect(() => {
    if (idPlanta) {
      loadPlanta();
    }
  }, [idPlanta, loadPlanta]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="container mx-auto"
    >
      {/* Sección contenedora como en PlantaDashboard */}
      {/*     <Card className="mb-6 border-2 border-primary/20">
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-start gap-4 flex-1">
              <div className="bg-primary/10 p-3 rounded-lg">
                <Archive className="h-5 w-5 text-primary" />
              </div>
              <div className="flex-1">
                <h1 className="text-2xl font-bold text-foreground">Depósito de Ropa</h1>
                <p className="text-muted-foreground">
                  {planta?.nombre ? `Planta: ${planta.nombre}` : 'Gestión de recepción y entrega de prendas'}
                </p>
              </div>
            </div>
            <Button asChild variant="outline">
              <Link to={`/plantas/${idPlanta}`}> 
                <ArrowLeft className="mr-2 h-4 w-4" /> Volver
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card> */}
      <div className="flex items-center justify-start mb-2">
        <Button asChild variant="outline" className="bg-primary/10 hover:bg-primary/20">
          <Link to={`/plantas/${idPlanta}`}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Volver
          </Link>
        </Button>
      </div>

      {/* Tabs Navigation */}
      <Card className="border-2 border-primary/20">
        <CardContent className="p-6">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="grid w-full grid-cols-3 mb-6">
              <TabsTrigger value="recoleccion" className="flex items-center gap-2">
                <Package className="h-4 w-4" />
                Recepción
              </TabsTrigger>
              <TabsTrigger value="alistamiento" className="flex items-center gap-2">
                <Layers className="h-4 w-4" />
                Alistamiento
              </TabsTrigger>
              <TabsTrigger value="entrega" className="flex items-center gap-2">
                <Hand className="h-4 w-4" />
                Entrega
              </TabsTrigger>
{/*               <TabsTrigger value="pendientes" className="flex items-center gap-2">
                <ClipboardList className="h-4 w-4" />
                Pendientes
              </TabsTrigger> */}
            </TabsList>

            <TabsContent value="recoleccion" className="space-y-6">
              <RecoleccionPrendas idPlanta={idPlanta} plantaNombre={planta?.nombre} />
            </TabsContent>

            <TabsContent value="casilleros" className="space-y-6">
              <CasillerosGestion idPlanta={idPlanta} plantaNombre={planta?.nombre} />
            </TabsContent>

            <TabsContent value="alistamiento" className="space-y-6">
              <AlistamientoPrendas idPlanta={idPlanta} plantaNombre={planta?.nombre} initialCedula={alistamientoCedula} onCedulaUsed={() => setAlistamientoCedula('')} />
            </TabsContent>

            <TabsContent value="entrega" className="space-y-6">
              <EntregaPrendas idPlanta={idPlanta} plantaNombre={planta?.nombre} onIrAlistamiento={irAlistamiento} />
            </TabsContent>

            <TabsContent value="pendientes" className="space-y-6">
              <PendientesEntrega idPlanta={idPlanta} plantaNombre={planta?.nombre} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default DepositoPage;
